//COMPASS
import CustomLink from '@common/components/CustomLink';
import PageHeader from '@common/models/PageHeader';
import StoreInfo from '@common/models/StoreInfo';
import { RouteMap } from '@common/RouteMap';
import { CartSliceType } from '@common/store/cart/slice';
import { CategoriesSliceType } from '@common/store/categories/slice';
import { FeaturesSliceType } from '@common/store/features/slice';
import { fetchProductsRequest } from '@common/store/products/slice';
import { fetchSearchRequest, SearchSliceType } from '@common/store/search/slice';
import { UserProfileSliceType } from '@common/store/userProfile/slice';
import { isBrowser } from '@common/utils';
import { computeRedirectUrl } from '@common/utils/computation';
import { getBuyerJWTToken } from '@common/utils/token';
import MobileSidebar from '@components/Layouts/MobileSidebar';
import User from '@images/LAccount.svg';
import { ReactComponent as MenuIcon } from '@images/LMenu.svg';
import SearchImg from '@images/LSearch.svg';
import SearchMobileImg from '@images/LSearchMobile.svg';
import Track from '@images/LTrack.svg';
import Button from '@lib/Button';
import Image from '@lib/Image';
import Link from '@lib/Link';
import OutsideClickHandler from '@lib/OutsideClickHandler';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import { isMobile } from '../../../common/utils';
import ThemeCart from '../common/ThemeCart';
import SearchModal from '../PageHeader7/helpers/Search';
import FilterBar from './helpers/FilterBar';
import Search from './helpers/Search';
import close from './images/Close.svg';

export interface NavBarProps {
  userProfile: UserProfileSliceType;
  cart: CartSliceType;
  storeInfo: StoreInfo;
  fetchSearchRequest: typeof fetchSearchRequest;
  search: Record<string, SearchSliceType>;
  features: FeaturesSliceType;
  categories: CategoriesSliceType;
  fetchProductsRequest: typeof fetchProductsRequest;
  pageHeader: PageHeader;
  ViewCart?: boolean;
  setViewCart?: () => void;
  id?: string;
}

const Navbar: React.FC<NavBarProps> = ({
  storeInfo,
  fetchSearchRequest,
  search,
  cart,
  features,
  categories,
  pageHeader,
  ViewCart,
  setViewCart,
  userProfile,
  id,
}) => {
  const [ShowSearch, SetShowSearch] = useState(false);
  const [isMobileSidebarShown, setIsMobileSidebarShown] = useState(false);
  const [focus, setfocus] = useState(false);
  const [ShowCart, setShowCart] = useState(false);
  const [title, setTitle] = useState(null);

  let filterBar = [];
  const redirectUrl = computeRedirectUrl();
  const filterBarLinks = pageHeader?.navbarLinks || [];
  const updatedFilterLinks = filterBarLinks?.filter((link) => link.storeLink !== '/');
  const navlinkDropdownItem = [{ id: '-1', name: 'Home', storeLink: '/' }, ...updatedFilterLinks, ...filterBar];

  useEffect(() => {
    setShowCart(ViewCart);
  }, [ViewCart]);

  if (updatedFilterLinks.length > 6) {
    const childObject = updatedFilterLinks.splice(6 - updatedFilterLinks.length - 1) || [];
    filterBar = [
      {
        id: 1111,
        name: 'More',
        label: 'More',
        storeLink: '#',
        childCategories: [...childObject],
      },
    ];
  }

  return (
    <div className="navbarLayout ph-3 pb-80 md:pb-150">
      <div className="fixed top-0 w-full z-60 bg-navbar-navBg shadow" color-customisation="header-bg" id={id}>
        <div
          className={classnames('', {
            'fixed inset-0 bg-navbar-navBg bg-opacity-80 md:hidden z-80 w-full h-full': focus,
          })}
        ></div>
        <div className="hidden md:block border-b border-searchBorder">
          <div className="hidden md:flex justify-between my-9 items-center md:h-90 container mx-auto relative">
            <Link to="/" className="font-medium text-20 text-navbar-textColor">
              {pageHeader?.logo ? (
                <Image noDefaultDimensions src={pageHeader?.logo} alt={storeInfo?.storename} className="h-64 rounded" />
              ) : (
                storeInfo?.storename
              )}
            </Link>
            <div className="relative">
              <OutsideClickHandler onOutsideClick={() => setfocus(false)}>
                <Search
                  className="rounded-lg"
                  fetchSearchRequest={fetchSearchRequest}
                  search={search}
                  placeholder={pageHeader?.searchText}
                  setfocus={(value) => {
                    setfocus(value);
                  }}
                />
              </OutsideClickHandler>
            </div>
            <div className="flex h-full text-center" font-customisation="section-heading">
              <div className="w-92 h-71 m-auto">
                <CustomLink
                  link={RouteMap.TRACK_ORDER}
                  className="text-navbar-textColor text-14"
                  color-customisation="header-links"
                >
                  <img
                    style={{
                      filter:
                        isBrowser() && window.location.pathname.includes('track-order') ? 'brightness(0.1)' : 'initial',
                    }}
                    src={Track}
                    alt="Track"
                    className="h-24 w-24 mb-4 mt-2 m-auto"
                  />
                  Track Order
                </CustomLink>
              </div>
              {features?.features?.buyerLogin && (
                <>
                  {!getBuyerJWTToken() ? (
                    <div className="w-92 h-71 m-auto">
                      <CustomLink
                        link={`/account/login?redirect_url=${redirectUrl}`}
                        className="text-navbar-textColor text-14"
                        color-customisation="header-links"
                      >
                        <img
                          style={{
                            filter:
                              isBrowser() && window.location.pathname.includes('account/login')
                                ? 'brightness(0.1)'
                                : 'initial',
                          }}
                          src={User}
                          alt="User"
                          className="h-24 w-24 mb-4 mt-2 m-auto"
                        />
                        Login
                      </CustomLink>
                    </div>
                  ) : (
                    <div className="w-92 h-71 m-auto">
                      <CustomLink
                        link={RouteMap.ACCOUNT_PROFILE}
                        className="text-navbar-textColor text-14"
                        color-customisation="header-links"
                      >
                        <img
                          style={{ filter: 'brightness(0.1)' }}
                          src={User}
                          alt="User"
                          className="h-24 w-24 mb-4 mt-2 m-auto"
                        />
                        Profile
                      </CustomLink>
                    </div>
                  )}
                </>
              )}
              <div className="w-92 h-71 m-auto">
                <ThemeCart
                  layout={pageHeader?.layout?.name}
                  setViewCart={setViewCart}
                  ShowCart={ShowCart}
                  setShowCart={setShowCart}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={classnames(
            'flex fixed bg-white w-full bottom-0 z-50 md:hidden px-42 py-8 h-60 items-center shadow-menubar',
            {
              'justify-between': features.features?.buyerLogin,
              'justify-around': !features.features?.buyerLogin,
            },
          )}
          font-customisation="section-heading"
        >
          <div className="">
            <CustomLink
              link={RouteMap.TRACK_ORDER}
              className="text-navbar-textColor text-12"
              color-customisation="header-links"
            >
              <img
                style={{ filter: 'brightness(0.1)' }}
                src={Track}
                alt="Track order"
                className="h-24 w-24 mb-4 mt-2 m-auto"
              />
              Track order
            </CustomLink>
          </div>
          {features.features?.buyerLogin ? (
            <div className="">
              {!getBuyerJWTToken() ? (
                <div className="">
                  <CustomLink
                    link={`/account/login?redirect_url=${redirectUrl}`}
                    className="text-navbar-textColor text-12"
                    color-customisation="header-links"
                  >
                    <img
                      style={{ filter: 'brightness(0.1)' }}
                      src={User}
                      alt="Login"
                      className="h-24 w-24 mb-4 mt-2 m-auto"
                    />
                    Login
                  </CustomLink>
                </div>
              ) : (
                <div className="">
                  <CustomLink
                    link={RouteMap.ACCOUNT_PROFILE}
                    className="text-navbar-textColor text-12"
                    color-customisation="header-links"
                  >
                    <img
                      style={{ filter: 'brightness(0.1)' }}
                      src={User}
                      alt="Profile"
                      className="h-24 w-24 mb-4 mt-2 m-auto"
                    />
                    Profile
                  </CustomLink>
                </div>
              )}
            </div>
          ) : null}
        </div>
        <div className="h-auto md:hidden">
          {!ShowSearch ? (
            <div className="flex px-16 justify-between h-80 items-center">
              <div className="flex">
                <div className="ml-4 mr-24 mt-4" style={{}}>
                  <MenuIcon
                    className="h-24 w-24"
                    onClick={() => {
                      setIsMobileSidebarShown(!isMobileSidebarShown);
                    }}
                  />
                </div>
                <div>
                  <Link to="/" className="font-medium text-20 text-navbar-textColor">
                    {pageHeader?.logo ? (
                      <Image
                        noDefaultDimensions
                        src={pageHeader?.logo}
                        alt={storeInfo?.storename}
                        className="h-34 rounded"
                      />
                    ) : (
                      storeInfo?.storename
                    )}
                  </Link>
                </div>
              </div>
              <div className="flex items-center justify-end">
                {!ShowSearch && (
                  <div className="mr-24" onClick={() => SetShowSearch(!ShowSearch)}>
                    <img src={isMobile() ? SearchMobileImg : SearchImg} className="h-24 w-24" alt="Search Icon" />
                  </div>
                )}
                <div className="flex flex-col relative items-center mr-8">
                  <ThemeCart
                    layout={pageHeader?.layout?.name}
                    setViewCart={setViewCart}
                    ShowCart={ShowCart}
                    setShowCart={setShowCart}
                    isMobile={true}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="fixed z-50 left-0 top-0 w-full h-full bg-pageHeader-gray31 opacity-80">
              <div>
                <Button
                  className="h-40 w-40 right-0 justify-end absolute mr-20 mt-20"
                  onClick={() => {
                    SetShowSearch(false);
                  }}
                >
                  <Image src={close} className="w-28 h-28" alt="Search Icon" />
                </Button>
              </div>
              <div className="relative navBarSearchMargin w-90p mx-auto my-130">
                <SearchModal
                  className="rounded-9"
                  fetchSearchRequest={fetchSearchRequest}
                  search={search}
                  placeholder={pageHeader?.searchText}
                  closeSearch={() => {
                    SetShowSearch(false);
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {isMobileSidebarShown ? (
          <MobileSidebar
            storeInfo={storeInfo}
            categories={categories}
            features={features}
            cart={cart}
            isMobileSidebarShown={isMobileSidebarShown}
            setIsMobileSidebarShown={(val) => {
              setIsMobileSidebarShown(val);
            }}
            filterBarLinks={navlinkDropdownItem || []}
            pageHeader={pageHeader}
            userProfile={userProfile}
            title={title}
            setTitle={(val) => setTitle(val)}
            filterBar={
              <FilterBar
                className=""
                categories={categories?.categories?.results || []}
                pageHeader={pageHeader}
                setTitle={(val) => setTitle(val)}
              />
            }
          />
        ) : null}
        <div className="hidden md:block">
          {categories.isFetched ? (
            <FilterBar
              className=""
              categories={categories?.categories?.results || []}
              pageHeader={pageHeader}
              setTitle={(val) => setTitle(val)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
